import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IChatItem, IConversationItem } from 'constants/chat.interface';

import { IChemicalData } from 'containers/ChatbotActiveChat/ChemicalSelector';
import { IFabricData } from 'containers/ChatbotActiveChat/fabricSelector';
import { IConditionData } from 'components/ProductSelectoreExposureSugessions';

import { IChemicalClass } from './chemicalStoreSlice';
import { Task } from './chemicalStoreSlice';

const chatItemInitialState: IChatItem = {
  isLoading: false,
  autoScroll: '',
  isNewChatItem: false,
  isAutoScrollDisabled: false,
  chat_history_id: null,
  isProductSelector: false,
  isPermeation: false,
  isInputDisabled: false,
  history: [],
  chemicals: [],
  conditions: [],
  chemicalList: [],
  chemicalClassList: [],
  chemicalSelectionType: '',
  industryTask: {} as Task,
  fabrics: [],
};

const activeChatItem = createSlice({
  name: 'chatHistory',
  initialState: chatItemInitialState,
  reducers: {
    setActiveChatData: (state, action: PayloadAction<IChatItem>) => ({ ...state, ...action.payload }),
    addNewQuery: (state, action: PayloadAction<IConversationItem>) => {
      state.history.push(action.payload);
      state.isLoading = true;
      state.isAutoScrollDisabled = false;
      return state;
    },
    addNewSelectorQuery: (state, action: PayloadAction<IConversationItem>) => {
      if (state.history.length > 0) {
        state.history[state.history.length - 1].controls = undefined;
      }
      state.history.push(action.payload);
      state.isLoading = true;
      state.isProductSelector = true;
      state.isInputDisabled = true;
      state.isAutoScrollDisabled = false;
      true;
      return state;
    },
    updateChatItemData: (state, action: PayloadAction<string>) => ({
      ...state,
      chat_history_id: action.payload,
      isNewChatItem: false,
      isPermeation: false,
      isProductSelector: false,
      chemicals: [],
      conditions: [],
      chemicalList: [],
      chemicalClassList: [],
      chemicalSelectionType: '',
      industryTask: {} as Task,
      fabrics: [],
    }),
    resetActiveChatData: () => chatItemInitialState,
    setAutoScroll: (state, action: PayloadAction<string>) => ({ ...state, autoScroll: action.payload }),
    setInputDisableState: (state, action: PayloadAction<boolean>) => ({ ...state, isInputDisabled: action.payload }),
    setChemicalsList: (state, action: PayloadAction<IChemicalData[]>) => ({
      ...state,
      chemicals: action.payload,
    }),
    setConditions: (state, action: PayloadAction<IConditionData[]>) => ({
      ...state,
      conditions: action.payload,
    }),
    setChemicalClassList: (state, action: PayloadAction<IChemicalClass[]>) => ({
      ...state,
      chemicalClassList: action.payload,
    }),
    setChemicalSelectionType: (state, action: PayloadAction<string>) => ({
      ...state,
      chemicalSelectionType: action.payload,
    }),
    setIndustry: (state, action: PayloadAction<Task>) => ({
      ...state,
      industryTask: action.payload,
    }),
    setFabricsList: (state, action: PayloadAction<IFabricData[]>) => ({
      ...state,
      fabrics: action.payload,
    }),
  },
});

export const {
  addNewQuery,
  setAutoScroll,
  setInputDisableState,
  setActiveChatData,
  updateChatItemData,
  addNewSelectorQuery,
  resetActiveChatData,
  setChemicalsList,
  setConditions,
  setChemicalClassList,
  setChemicalSelectionType,
  setIndustry,
  setFabricsList,
} = activeChatItem.actions;

export default activeChatItem.reducer;
